import { ReactNode } from 'react'

import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export interface Loop {
  loop: boolean
  loopedSlides: number
}

export enum ARROW_COLOR {
  WHITE = 'white',
  BLACK = 'black',
}

export enum DOTS_POSITION {
  BOTTOM = 'bottom',
  BOTTOM_HOVER = 'bottom_hover',
  TOP = 'top',
}

export interface SwiperProps {
  autoplaySpeed?: number
  numberOfVisibleSlides?: number | undefined
  variableWidth?: boolean
  showNavigator?: boolean
  showDots?: boolean
  className?: string
  slideClassName?: string
  infinite?: Loop
  tracker?: string
  arrowColor?: ARROW_COLOR
  children: ReactNode
  freeMode?: boolean
  dotsPosition?: DOTS_POSITION
  id?: string
  autoplay?: boolean
  breakpoints?: {
    [width: number]: any
    [ratio: string]: any
  }
  isChevronIcon?: boolean
  isVertical?: boolean
  withChildWrapper?: boolean
  disableSwipe?: boolean
  afterChange?: (swiperInstance: any) => void
  navPosition?: NAV_POSITION
  isStickyFreeMode?: boolean
  virtualOptions?: any
  initialSlide?: number
  centeredSlides?: boolean
  prevIconClass?: string
  nextIconClass?: string
  arrowOnClick?: ({ ...args }: { direction: string }) => void
  spaceBetween?: string | number | undefined
  arrowWrapperClass?: string
  swiperId?: string
  isIconWithBG?: boolean
  trackingMetaData?: TrackingMetaData
  wrapperClass?: string
  handleOnScrollEvent?: () => void
  preventInteractionOnTransition?: boolean
  ariaLabel?: string | undefined
}

export enum NAV_POSITION {
  LEFT = 'LEFT',
  RIGHT_WITH_PADDING = 'RIGHT_WITH_PADDING',
  RIGHT = 'RIGHT',
  CENTER = 'center',
  RIGHT_OVER_IMAGE = 'RIGHT_OVER_IMAGE',
  BOTTOM_RIGHT_OVER_IMAGE = 'BOTTOM_RIGHT_OVER_IMAGE',
  RIGHT_WITH_BOTTOM_PADDING = 'RIGHT_WITH_BOTTOM_PADDING',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  VERTICAL = 'VERTICAL',
  LEFT_RIGHT = 'LEFT_RIGHT',
}

export interface ArrowProps {
  className?: string
  onClick?: (...args: any) => void
  isWhite?: boolean
  tracker?: string
  arrowColor?: ARROW_COLOR
  disabled?: boolean
  id?: string
  ariaLabel?: string
  isChevronIcon?: boolean
  isVertical?: boolean
  isIconWithBG?: boolean
  trackingMetaData?: TrackingMetaData
}
